"use client"
/* */
import { getPropsMerger } from '../react/getPropsMerger.mjs';

const merger = getPropsMerger({
  mergeClassNames: false,
  mergeEventHandler: false
});
const mergePropsContext = (firstContext = {}, secondContext = {}) => {
  const mergedComponentNames = Object.keys({
    ...firstContext,
    ...secondContext
  });
  return Object.fromEntries(
    mergedComponentNames.map((componentName) => [
      componentName,
      merger(
        firstContext[componentName],
        secondContext[componentName]
      )
    ])
  );
};

export { mergePropsContext as default, mergePropsContext };
//# sourceMappingURL=mergePropsContext.mjs.map
